'use strict';

/*global services*/
/*global isEmpty*/
/*global blockElement*/
/*global unBlockElement*/

$(document).ready(function () {
  function loadPanelData($panel) {
    if ($panel.hasClass('panel-load-on-demand')) {
      if (!$panel.hasClass('panel-collapsed')) {
        if (isEmpty($panel.find('.panel-body').html())) {
          var articleId = $panel.data('article_id');
          var parameters = $panel.data('parameters');
          var $wrapper = $panel.find('.panel-body');
          blockElement($wrapper);
          $.get(services.get('router').path($panel.data('route'), { articleId: articleId }) + (parameters ? '?' + parameters : ''), function (res) {
            unBlockElement($wrapper);

            if (res.msg === 'SUCCESS') {
              $wrapper.html(res.data.html);
            } else {
              services.get('notifications').viewErrorMessage();
            }
          });
        }
      }
    }
  }

  $('.panel-collapsible').k2_panelCollapsible({
    init: function () {
      loadPanelData($(this));
    },

    open: function () {
      loadPanelData($(this));
    }
  });
});
